import { useState, forwardRef, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { useController } from 'react-hook-form';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import { es, enUS } from 'date-fns/locale';
import { useSelector } from 'react-redux';
import { getDateByStringDate } from '../../utils';

registerLocale('es', es);
registerLocale('en', enUS);

// Componente personalizado para el campo de entrada
const CustomInput = forwardRef(({ value, onClick, inputClass, placeholder }, ref) => (
  <input
  // w-100 app-fs-1 border-0 ps-0 shadow-none py-0 app-fs-14 text-uppercase form-control
    className={`w-100 border-0 ps-0 shadow-none form-control ${inputClass}`}
    type="text"
    value={value}
    placeholder={placeholder}
    onClick={onClick} // Abre el calendario al hacer clic
    readOnly // Evita que el teclado aparezca
    style={{ cursor: 'pointer' }} // Cambia el cursor para indicar que es clickeable
    ref={ref}
  />
));

// Asignar un displayName al componente
CustomInput.displayName = 'CustomInput';

function CustomDateInput({
  control,
  name,
  rules,
  defaultValue = '',
  icon = null,
  formLabel = '',
  classNames = {},
  blockDate = null,
  blockFutureDate = null,
  showMoth = false,
  showYear = false,
  disabled = false,
  placeHolder = 'DD/MM/YYYY',
}) {
  const language = useSelector((state) => state.checking.language);
  const normalizedLocale = language?.toLowerCase() === 'es' ? 'es' : 'en';
  // Integracion con React Hook Form
  const {
    field: { value, onChange, onBlur },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  useEffect(() => {
    // console.log(value);
  }, [value]);

  // Funcion para manejar el cambio del valor
  const handleOnChange = (date) => {
    onChange(date); // Actualiza el valor en React Hook Form
  };

  // Funcion para manejar el focus del input
  // const handleOnBlur = (option) => {};
  // console.log(blockDate)
  // const parsedBlockDate = blockDate ? new Date() : null;
  const parsedBlockDate = blockDate ? getDateByStringDate(blockDate) : null;
  // console.log(parsedBlockDate)

  return (
    <div className="custom-input position-relative">
      {/* <Card className={`${classNames?.card} mt-2 lh-sm`}> */}
      <Card className={`${classNames?.card} ${error ? 'invalid-input-border' : ''}`}>
        <Card.Body className={`${classNames?.cardBody} p- pt-`}>
          <div className="d-flex">
            { icon && (
              <div className={`checking__group-icon ${classNames.icon} d-flex align-items-center`}>
                <img src={icon} alt={`icon-${name}`} className="img-fluid-33"/>
              </div>
            )}

            <Form.Group className="flex-fill" controlId={`control-${name}`}>
              {formLabel && (<Form.Label className={`${classNames?.label} mb-0`}>{formLabel}</Form.Label>)}
              <DatePicker
                // className="w-100 app-fs-1 border-0 ps-0 shadow-none form-control"
                selected={value} // Valor del campo
                // onSelect={handleDateSelect} // Se activa cuando hace click en la fecha
                onChange={handleOnChange} // Se activa cuando el valor ha cambiado
                dateFormat="dd/MM/yyyy" // Formato de la fecha
                placeholderText={placeHolder}
                peekNextMonth
                minDate={parsedBlockDate} // Bloquea fechas pasadas
                // Bloquea fechas futuras si blockFutureDate
                maxDate={blockFutureDate ? new Date() : null}
                showMonthDropdown={showMoth}
                showYearDropdown={showYear}
                dropdownMode="select"
                locale={normalizedLocale}
                // readOnly
                disabled={disabled}
                // onFocus={(e) => e.target.blur()} // Evita que el teclado aparezca
                // Usa el componente personalizado
                customInput={
                  (<CustomInput inputClass={classNames?.input} placeholder={placeHolder} />)
                }
                popperPlacement="top-start" // "bottom-start", "top-end", etc.
                popperModifiers={{
                  preventOverflow: {
                    enabled: true,
                    boundariesElement: 'viewport', // Evita que se salga de la pantalla
                  },
                }}
              />
              {/* <Form.Text className="text-muted">
                We'll never share your email with anyone else.
              </Form.Text> */}
            </Form.Group>
          </div>
        </Card.Body>
      </Card>

      {/* Mostrar mensaje de error */}
      {/* {error && <span className="error-message">{error.message}</span>} */}
    </div>
  );
}

export default CustomDateInput;
